export const SET_CONVERSATION = "SET_CONVERSATION";
export const CLEAR_CONVERSATION = "CLEAR_CONVERSATION";
